// The stage uses the original illustration's units, so props can be placed relative to the students.
// One unit is var(--u) in CSS. The ground line sits at y = 114, where the student artwork is cut off.
export const ORIGIN_X = -35;
export const ORIGIN_Y = -20;
export const STAGE_WIDTH = 155;
export const STAGE_HEIGHT = 134;

export function units(value) {
    return `calc(${value} * var(--u))`;
}

export function place(x, y) {
    return {
        left: units(x - ORIGIN_X),
        top: units(y - ORIGIN_Y)
    };
}
